import {t} from "i18next";
import i18n from "../i18n";

import {format, subDays as fnSubDays, formatDistanceToNow as fnFormatDistanceToNow} from "date-fns";

// Format a date using date-fns
export const formatDate = (date: Date, formatStr: string): string => {
    // Map our custom format strings to date-fns format strings
    let dateFormat: string;

    switch (formatStr) {
        case "yyyy-MM-dd":
            dateFormat = "yyyy-MM-dd";
            break;
        case "MM/dd":
            dateFormat = "MM/dd";
            break;
        default:
            dateFormat = "MM/dd/yyyy";
    }

    return format(date, dateFormat);
};

// Subtract days from a date using date-fns
export const subDays = (date: Date, days: number): Date => {
    return fnSubDays(date, days);
};
export function formatTimeAgo(timestamp: string) {
    const date = new Date(timestamp);
    const now = new Date();
    const diffInHours = (now.getTime() - date.getTime()) / (1000 * 60 * 60);
    const rtf = new Intl.RelativeTimeFormat(i18n.language, {numeric: "auto"});

    if (diffInHours < 24) {
        return rtf.format(-Math.floor(diffInHours), "hour");
    } else if (diffInHours < 48) {
        return t("common.yesterday");
    } else if (diffInHours < 168) {
        // 7 days
        return new Intl.DateTimeFormat(i18n.language, {weekday: "long"}).format(
            date
        );
    } else {
        return new Intl.DateTimeFormat(i18n.language, {
            day: "numeric",
            month: "short",
        }).format(date);
    }
}

// Format distance to now using date-fns
export const formatDistanceToNow = (date: Date): string => {
    return fnFormatDistanceToNow(date, { addSuffix: true });
};
